import { Box, TextField } from "@mui/material";
import { InputLabel } from "./InputLabel";

export const InputWithLabel = ({
  placeholder,
  value,
  onChange,
  error,
  name,
  label = null,
}) => {
  return (
    <Box
      display={"flex"}
      alignItems={"start"}
      justifyContent={"center"}
      flexDirection={"column"}
      rowGap={0.5}
    >
      {label ? <InputLabel label={label} /> : <></>}
      <TextField
        name={name}
        size="small"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        sx={{
          width: "100%",
        }}
        error={Boolean(!!error)}
        helperText={error}
      />
    </Box>
  );
};
